module.exports = __webpack_public_path__ + "img/PL09291.ec6a1080.png";